<template>
  <v-img
      :src="src"
      :height="$vuetify.breakpoint.mdAndUp ? 180 : 240"
      aspect-ratio="2.75"
  >
    <div class="overlay" />

   <v-fade-transition>
     <template v-show="show">
       <v-layout
           class="phrase-wrapper pt-2"
           align-center
           justify-center
           wrap
       >
         <v-flex xs12 md4 text-xs-center py-0 px-4>
           <v-layout justify-center align-center wrap>
             <v-flex xs12 text-xs-center text-md-left>
               <div class="display-2 font-weight-light">
                 {{now.day}}
               </div>
             </v-flex>
             <v-flex xs12 text-xs-center text-md-left>
               <div class="title font-weight-light ml-2">
                 {{now.month}}
               </div>
             </v-flex>
           </v-layout>
         </v-flex>
         <v-flex xs12 md8 text-xs-center text-md-right py-4 px-3>

           <div v-cloak class="message-div mt-4">
             <p class="message-p">
               <i class="fas fa-quote-left icon-quote"></i> {{ phrase.description }}
               <i class="fas fa-quote-right icon-quote"></i>
             </p>
             <p class="author-p">- {{ phrase.author }}</p>
           </div>
         </v-flex>

       </v-layout>
     </template>
   </v-fade-transition>


  </v-img>
</template>

<script>
export default {
name: "PositiveBanner",
  props:{
    phrase: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      show: false
      }
  },
  mounted(){
    const vm = this
    setTimeout(function(){
      vm.show = true
    }, 1000)
  },
  computed:{
    src(){
      let rand = Math.floor(Math.random() * 11) + 1;
      return require(`@/assets/img/dashboard/positive/${rand}.jpg`)
    },
    now(){
      const vm = this
      const now = vm.$moment()
      return {
        day: now.format('ddd DD').toUpperCase(),
        month: now.format('MMMM Y')
      }
    }
  }
}
</script>

<style scoped>
  .overlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255, .7);
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.4266750645570728) 100%);
  }

  .phrase-wrapper{
    position: relative;
    z-index: 1;

  }

  .icon-quote {
    font-size: 22px;
  }
  .author-p {
    font-size: 18px;
    font-style: italic;
    padding-left: 60%;
    padding-top: 5px;
    margin-right: 10px;
  }
  .message-p {
    font-size: 22px;
  }
</style>